<tam-dialog [opened]="dialogOpened" [dialogWidth]="500" class="web-sites-dialog-container" [opened]="dialogOpened">
    <ng-template #title>
        <span class="dialog-title">{{dialogTitle}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="cancelClick()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="dialog-body">
            <div class="content">
                <div class="content-form">
                    <form>
                        <div class="dialog-body-field">
                            <input type="text" id="filePath" class="tam-textbox" name="filePath" [(ngModel)]="filePath"
                                required>
                            <div class="field-help" [hidden]="filePath"
                                [ngStyle]="{'color':isFilePathEmpty === false ? 'white' : '#f53249' }">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-button">
            <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                (click)="onSumbit()">{{'general.submit'
                | stringLiterals}}</button>
        </div>
    </ng-template>
</tam-dialog>